import * as LuIcons from 'react-icons/lu';
// Remplace LuBarChart3 par LuTrendingUp pour garantir l'affichage de l'icône Audit
const { LuShieldCheck, LuBookOpen, LuScale, LuLaptop, LuTrendingUp } = LuIcons;
import { NavLink, ServiceItem, TrainingModule } from './types';

export const NAV_LINKS: Record<string, NavLink[]> = {
  fr: [
    { label: 'Accueil', path: '/' },
    { label: 'Services', path: '/services' },
    { label: 'Formations', path: '/formations' },
    { label: 'Logiciels', path: '/logiciels' },
    { label: 'Contact', path: '/contact' }
  ],
  en: [
    { label: 'Home', path: '/' },
    { label: 'Services', path: '/services' },
    { label: 'Training', path: '/formations' },
    { label: 'Software', path: '/logiciels' },
    { label: 'Contact', path: '/contact' }
  ]
};

export const SERVICES: Record<string, ServiceItem[]> = {
  fr: [
    {
      id: 'smi',
      title: 'Système de Management Intégré',
      description: 'Accompagnement complet vers la certification ISO et l\'excellence opérationnelle.',
      icon: LuShieldCheck,
      details: ['Qualité (ISO 9001)', 'Sécurité Alimentaire (ISO 22000)', 'Santé & Sécurité (ISO 45001)', 'Environnement (ISO 14001)']
    },
    {
      id: 'audit',
      title: 'Audit & Expertise',
      description: 'Diagnostics précis pour garantir votre conformité sociale et financière.',
      icon: LuTrendingUp,
      details: ['Audit Social (ETI, SMETA)', 'Audit Comptable', 'Audit Financier', 'Due Diligence']
    },
    {
      id: 'metrologie',
      title: 'Métrologie',
      description: 'L\'étalonnage donne la connaissance, la vérification donne la confiance.',
      icon: LuScale,
      details: ['Étalonnage', 'Vérification', 'Essais techniques', 'Gestion de parc']
    },
    {
      id: 'logiciels',
      title: 'Pôle Logiciels & IT',
      description: 'Digitalisation de vos processus métiers et maintenance informatique.',
      icon: LuLaptop,
      details: ['Installation SAGE', 'Maintenance SAGE (Paie/Compta)', 'Maintenance Informatique', 'Réseaux']
    }
  ],
  en: [
    {
      id: 'smi',
      title: 'Integrated Management System',
      description: 'Comprehensive support towards ISO certification and operational excellence.',
      icon: LuShieldCheck,
      details: ['Quality (ISO 9001)', 'Food Safety (ISO 22000)', 'Health & Safety (ISO 45001)', 'Environment (ISO 14001)']
    },
    {
      id: 'audit',
      title: 'Audit & Expertise',
      description: 'Precise diagnostics to ensure your social and financial compliance.',
      icon: LuTrendingUp,
      details: ['Social Audit (ETI, SMETA)', 'Accounting Audit', 'Financial Audit', 'Due Diligence']
    },
    {
      id: 'metrologie',
      title: 'Metrology',
      description: 'Calibration provides knowledge, verification provides confidence.',
      icon: LuScale,
      details: ['Calibration', 'Verification', 'Technical testing', 'Fleet management']
    },
    {
      id: 'logiciels',
      title: 'Software & IT Division',
      description: 'Digitalization of your business processes and IT maintenance.',
      icon: LuLaptop,
      details: ['SAGE Installation', 'SAGE Maintenance (Payroll/Accounting)', 'IT Maintenance', 'Networks']
    }
  ]
};

export const TRAININGS: Record<string, TrainingModule[]> = {
  fr: [
    {
      id: '1',
      title: 'Responsable QHSE',
      category: 'QHSE',
      duration: '5 Jours',
      targetAudience: 'Directeurs, Managers, Ingénieurs et techniciens QHSE.',
      addedValue: 'Maîtrise complète de l\'intégration des normes ISO 9001, 14001 et 45001.',
      image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&q=80&w=800'
    },
    {
      id: '2',
      title: 'Auditeur Interne ISO 9001',
      category: 'QHSE',
      duration: '3 Jours',
      targetAudience: 'Responsables qualité, cadres opérationnels et futurs auditeurs.',
      addedValue: 'Capacité à piloter des audits internes créateurs de valeur pour l\'entreprise.',
      image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&q=80&w=800'
    },
    {
      id: '3',
      title: 'SAGE Comptabilité & Paie',
      category: 'Gestion',
      duration: '1 Semaine',
      targetAudience: 'Comptables, gestionnaires de paie, Directeurs RH.',
      addedValue: 'Automatisation optimale des processus financiers et conformité légale de la paie.',
      image: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&q=80&w=800'
    },
    {
      id: '4',
      title: 'Sécurité Incendie (EPI/ESI)',
      category: 'Sécurité',
      duration: '2 Jours',
      targetAudience: 'Ensemble du personnel, équipes de première et seconde intervention.',
      addedValue: 'Conformité réglementaire et réflexes vitaux pour la protection des biens et des personnes.',
      image: 'https://images.unsplash.com/photo-1611270418597-a6c77f4b7271?auto=format&fit=crop&q=80&w=800' // Updated Image
    },
    {
      id: '5',
      title: 'Management des RH',
      category: 'RH',
      duration: '3 Jours',
      targetAudience: 'Chefs d\'entreprise, DRH, Managers de proximité.',
      addedValue: 'Amélioration de la rétention des talents et du climat social organisationnel.',
      image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80&w=800'
    },
    {
      id: '6',
      title: 'Secourisme au travail',
      category: 'Sécurité',
      duration: '2 Jours',
      targetAudience: 'Salariés désignés comme sauveteurs secouristes du travail (SST).',
      addedValue: 'Réduction de la gravité des accidents de travail par une intervention immédiate.',
      image: 'https://images.unsplash.com/photo-1516574187841-cb9cc2ca948b?auto=format&fit=crop&q=80&w=800'
    }
  ],
  en: [
    {
      id: '1',
      title: 'QHSE Manager',
      category: 'QHSE',
      duration: '5 Days',
      targetAudience: 'Directors, Managers, Engineers and QHSE technicians.',
      addedValue: 'Complete mastery of the integration of ISO 9001, 14001 and 45001 standards.',
      image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&q=80&w=800'
    },
    {
      id: '2',
      title: 'ISO 9001 Internal Auditor',
      category: 'QHSE',
      duration: '3 Days',
      targetAudience: 'Quality managers, operational executives and future auditors.',
      addedValue: 'Ability to lead internal audits that create value for the company.',
      image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&q=80&w=800'
    },
    {
      id: '3',
      title: 'SAGE Accounting & Payroll',
      category: 'Management',
      duration: '1 Week',
      targetAudience: 'Accountants, payroll managers, HR Directors.',
      addedValue: 'Optimal automation of financial processes and legal compliance of payroll.',
      image: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&q=80&w=800'
    },
    {
      id: '4',
      title: 'Fire Safety (EPI/ESI)',
      category: 'Safety',
      duration: '2 Days',
      targetAudience: 'All staff, first and second intervention teams.',
      addedValue: 'Regulatory compliance and vital reflexes for the protection of property and people.',
      image: 'https://images.unsplash.com/photo-1611270418597-a6c77f4b7271?auto=format&fit=crop&q=80&w=800' // Updated Image
    },
    {
      id: '5',
      title: 'HR Management',
      category: 'HR',
      duration: '3 Days',
      targetAudience: 'Business leaders, HRDs, Frontline managers.',
      addedValue: 'Improvement of talent retention and organizational social climate.',
      image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80&w=800'
    },
    {
      id: '6',
      title: 'Occupational First Aid',
      category: 'Safety',
      duration: '2 Days',
      targetAudience: 'Employees designated as occupational first aiders (SST).',
      addedValue: 'Reduction in the severity of workplace accidents through immediate intervention.',
      image: 'https://images.unsplash.com/photo-1516574187841-cb9cc2ca948b?auto=format&fit=crop&q=80&w=800'
    }
  ]
};

export const CONTACT_INFO = {
  address: "En face cinéma l'Eden, Douala, Cameroun",
  phones: ["+237 656 04 13 09", "+237 658 04 59 48"],
  email: "contact@be-consulting.pro",
  mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3979.799784386762!2d9.700000!3d4.050000!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTPCsDAzJzAwLjAiTiA5wrA0MicwMC4wIkU!5e0!3m2!1sen!2scm!4v1600000000000!5m2!1sen!2scm"
};